module.exports = __webpack_public_path__ + "Assets/838d632a-68b5-43fe-8b43-78c397691c74.svg";